import { DefaultTheme } from "styled-components"

export const LightTheme: DefaultTheme = {
  primaryColor: "#DA2020",
  secondaryColor: "",
  textColor: "#130304",
  backgroundColor: "white",
  cardBackgroundColor: "rgba(255, 255, 255, 0.5)",
}
